import React from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedin, FaYoutube } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import '../Styles/Footer.css'; // Import the external CSS file

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo Section */}
        <div className="footer-logo">
          <h2>Bookurspot</h2>
        </div>

        {/* Footer Links */}
        <div className="footer-links">
          <div>
            <h3>ABOUT US</h3>
            <ul>
              <li><Link to="/who-we-are">Who We Are</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/work-with-us">Work With Us</Link></li>
              <li><Link to="/investor-relations">Investor Relations</Link></li>
              <li><Link to="/report-fraud">Report Fraud</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
            </ul>
          </div>
          <div>
            <h3>PRODUCTS</h3>
            <ul>
              <li><Link to="/venues">Venues</Link></li>
              <li><Link to="/events">Events</Link></li>
              <li><Link to="/partnerwithus">Partner With Us</Link></li>
            </ul>
          </div>
          <div>
            <h3>RESOURCES</h3>
            <ul>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/security">Security</Link></li>
            </ul>
          </div>
          <div>
            <h3>FOLLOW US</h3>
            <div className="footer-social-icons">
              <a href="https://facebook.com"><FaFacebookF /></a>
              <a href="https://instagram.com"><FaInstagram /></a>
              <a href="https://twitter.com"><FaTwitter /></a>
              <a href="https://linkedin.com"><FaLinkedin /></a>
              <a href="https://youtube.com"><FaYoutube /></a>
            </div>
          </div>
        </div>

        {/* Download App Section */}
        <div className="footer-download">
          <p>Download our app for a seamless booking experience:</p>
          <div className="footer-download-links">
            {/*<img src={`${process.env.PUBLIC_URL}/Beachday.png`} alt="Bookurspot Branding" /> */}
            <a href="https://apps.apple.com">
              <img src={`${process.env.PUBLIC_URL}/appstore-logo.png`} alt="Download on the App Store" />
            </a>
            <a href="https://play.google.com">
              <img src={`${process.env.PUBLIC_URL}/playstore-logo.png`} alt="Get it on Google Play" />
            </a>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Bookurspot. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
